module.exports = __webpack_public_path__ + "static/media/plus-blue.c8f710a3.svg";